/* global mapboxgl:true */
import { store, actions } from "./store";

mapboxgl.accessToken =
  "pk.eyJ1IjoibWFkZWJ5bWlrZSIsImEiOiJsRmJ2WTFvIn0.vAjq0NGB6sn-6gy48wGH2Q";

class mapboxMap {
  constructor() {
    this.element = document.createElement("div");
    this.element.classList.add("mapboxMap");
    this.map = new mapboxgl.Map({
      container: this.element,
      style: "mapbox://styles/mapbox/dark-v9",
      center: [134.956, -28.033],
      zoom: 2.8
    });
    this.drawMarkers = this.drawMarkers.bind(this);
    store.subscribe(state => this.drawMarkers(state));
    this.markers = [];
    this.map.on("load", _ => {
      this.drawMarkers(store.getState());
    });

    this.element.addEventListener(
      "mouseenter",
      e => {
        store.setState({ activeItem: 0 });
      },
      false
    );
  }

  drawMarkers(state) {
    // Remove existing markers
    this.markers.forEach(marker => {
      marker.remove();
    });

    // Redraw markers
    state.items.forEach(item => {
      var el = document.createElement("div");
      el.classList.add("marker");
      el.classList.add(item.color);
      if (state.hoverItem === item.id) {
        el.classList.add("active");
      }
      const marker = new mapboxgl.Marker(el);
      marker.setLngLat(item.coordinates);
      marker.addTo(this.map);
      // Keep track of drawn markers in local state
      this.markers.push(marker);

      el.addEventListener(
        "mouseenter",
        e => {
          store.setState({ activeItem: item.id });
        },
        false
      );
    });
  }
}

export { mapboxMap };
